/**
 * v-sync-height 디렉티브
 * 
 * @작동 
 *   v-sync-height 디렉티브를 지정한 element의 높이를 화면의 크기에 맞춰준다.
 * 
 * @원리
 *   부모의 display 를 flex, flex-direction 을 column 으로 만들어준다.
 *   flex css의 효과로 형제들과 어울어진 높이가 꽉찬 element가 된다.
 *   컨테이너를 스크린에 꽉차게 됐을 경우를 가정하고 컨테이너 높이를 계산하고 남는 만큼의 높이를 element에 적용한다.
 * 
 * @전달인자
 *  model : 변수로 쓸 model 키 ( default undefined)
 *          model 이 없으면 element 에 직접 style 을 적용한다.
 *          model 이 있으면 model 에 높이값만 할당하고 style 은 적용하지 않낟.
 *  offset : 자동 계산된 크기에서 offset 만큼 추가로 조정 한다. (default 0)
 *  condition: 조건이 참일 경우만 실행 ( default true )
 *  style : 높이를 적용할 스타일 
 *          height | min-height (default height)
 * 
 * @author force.andwise.com
 * 
 * 
 */

import $ from 'jquery'
import * as util from '@/util/util'


/**
 * sync-height 실행
 * @param {} el 
 * @param {*} value 
 * @param {*} modifiers 
 * @param {*} vnode 
 * @returns 
 */
const calcHeight = ( el ) => {

    const { value, modifiers, vnode } = el.syncHeightObject
if(true) {
    //return
}    
    // 조건이 참일 경우만 실행 
    if(value?.condition === false) {
        return
    }


    // 화면에 보이지 않으면 종료
    if(!$(el).is(':visible')) {
        return
    }

    // 자식 중 동일 디렉티브가 있으면 종료
    if($(el).find('[data-sync-height]').length > 0) {
        // 모델에 연결돼 있으면 모델값 셋팅
        if(value?.model) {
            // 모델에 저장 
            setModel(value?.model, vnode, $(el).height())
        }    
        return
    }

    // 모달에 있는 디렉트브인지 확인
    const $modalContainer = $(el).closest('.vm--modal')

    if($modalContainer.length > 0) {
        // 모달용 sync
        getHeightByModal( $modalContainer, el, value, modifiers, vnode )
    } else {
        // 일반 sync
        const $container = $('.content > ')
        getHeightByContent( $container, el, value, modifiers, vnode )

    }    


}
/**
 * 부모가 flex 이면서 direction 이 row 이면 v-sysn-height 을 쓸 수 없다.
 * 오류를 발생시킴
 * @param {*} el 
 */
const checkParentDirection = ( el ) => {

    const $parent = $(el).parent()

    if($parent.css('display') === 'flex' && $parent.css('flex-direction') === 'row') {
        const msg = 'v-sync-height 을 사용할 수 없는 element 입니다.\n부모의 flex-direction 이 \'column\' 으로 만들기 때문에  이미 \'row\'인 경우는 v-sync-height 를 사용할 수 없습니다.'
        console.log(el, msg)
        alert(msg + '\콘솔을 확인 해 주세요')
        throw new Error(msg)
    }

}

/**
 * 모달 기준 sync-height
 * @param {} $modalContainer 
 * @param {*} el 
 * @param {*} exp 
 * @param {*} modifiers 
 * @param {*} vnode 
 */
const getHeightByModal = ( $modalContainer, el, value, modifiers, vnode ) => {

    console.log(el)

    checkParentDirection( el )

    $(el).parent().css({display:'flex', 'flex-direction':'column'})
    $(el).css('flex','auto')

    // if(findOtherDirective($modalContainer, el)) {
        //return
    // }

    const containerHeight =  $modalContainer.height()
    const $firstChild = $modalContainer.find('>')
    const firstChildHeight = $firstChild.outerHeight()

    const newHeight = containerHeight - firstChildHeight + $(el).outerHeight() - (value?.offset || 0)

    if(value?.model) {
        // 모델에 저장 
        setModel(value?.model, vnode, newHeight)
    } else {
        // 모델이 없으면 el 에 style 적용 
        $(el).css( (value?.style || 'height'), newHeight)
    }
    el.cnt = (el?.cnt || 0) + 1
    $(el).attr('data-sync-height', el.cnt)


}

/**
 * 일반 컨텐츠 기준 sync-height
 * @param {} $container 
 * @param {*} el 
 * @param {*} value 
 * @param {*} modifiers 
 * @param {*} vnode 
 */
const getHeightByContent = ( $container, el, value, modifiers, vnode ) => {

    checkParentDirection( el )

    $(el).parent().css({display:'flex', 'flex-direction':'column'})
    $(el).css('flex','auto')

    // if(findOtherDirective($modalContainer, el)) {
        //return
    // }

    //상단지점 부터 컨테이너 높이까지가 기준영역
    const containerHeight =  $container.offset().top + $container.height()
    

    let height = containerHeight - $(el).outerHeight( true )

    // 부모 패딩 제외
    const $containerWrap = $container.parent()
    const marginPadding = parseInt($containerWrap.css('padding-bottom'))
    height += marginPadding

    // 강제로 여유주기
    height += 25 - (value?.offset || 0)

    // 화면에 꽉차기 위해 필요한 자신의 높이
    height = ($(window).height() - height) 


    if(value.model) {
        // 모델에 저장 
        setModel(value.model, vnode, height)
    } else {
        // 모델이 없으며 el 에 style 적용 
        $(el).css((value?.style || 'height'),height)
    }
    el.cnt = (el?.cnt || 0) + 1
    $(el).attr('data-sync-height', el.cnt)


}


/**
 * 다른 v-sync-height 디렉티브 검색
 */
 const findOtherDirective = ( $container, el ) => {

    let $other

    $container.find('[data-sync-height]:visible').each((idx,element) => {
        if(element !== el && (element?.cnt || 0) > (el?.cnt || 0) ) {
            $other = $(element)
        }
    })

    return $other

}

/**
 * 모델에 값 셋팅
 */
const setModel = (modelKey, vnode, height) => {

    if(!modelKey) return

    // 모델에 . 이있으면 분해
    if(modelKey.indexOf('.') > -1) {

        let obj = vnode.context.$data
        const tokens = modelKey.split('.')
        for(let i=0; i<tokens.length-1; i++) {
            obj = obj[tokens[i]]
        }
        obj[tokens[tokens.length-1]] = height

    } else {

        vnode.context.$data[modelKey] = height 

    }    
    
}

/**
 * 지연된 높이계산 
 */
const delayRun = ( el, delay ) => {

        clearTimeout(el.___syncHeightTimeout)
        el.___syncHeightTimeout = 
        setTimeout(() => {
            calcHeight( el )
        }, delay)
            

}

/**
 * v-sync-height="model"
 */
export default {

    bind(el, {value, modifiers}, vnode) {
        
        if(!el._uuid) el._uuid = util.getUUID()
        el.syncHeightObject = { value, modifiers, vnode }

        const eventName = `resize.${el._uuid}`

        $(window).on(eventName, () => {
            delayRun(el, 100 )
        })

    },

    inserted(el, {name, value, oldValue, expression, arg, modifiers}, vnode, oldvNode) {
        
        el.syncHeightObject = { value, modifiers, vnode }
        delayRun( el )
    },
    update(el, {name, value, oldValue, expression, arg, modifiers}, vnode, oldvNode) {
        
        el.syncHeightObject = { value, modifiers, vnode }
        delayRun( el )
    },
    /**
     * 포함하고 있는 컴포넌트와 그 자식들 이 업데이트 된 후에 호출
     */
    componentUpdated(el, {name, value, oldValue, expression, arg, modifiers}, vnode, oldvNode) {
        
        el.syncHeightObject = { value, modifiers, vnode }
        delayRun( el )
    },

    unbind(el, {name, value, oldValue, expression, arg, modifiers}, vnode, oldvNode) {

        const eventName = `resize.${el._uuid}`

        $(window).off(eventName)
    }


}